module.exports = __webpack_public_path__ + "static/img/hotel-karosta-3.0ea567b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/articles/1911262/hotel-karosta-3.jpg
// module id = WCj4
// module chunks = 1